<template>
	<div class="project" :class="{ 'gray': gray}">
		<div class="box">
			<!-- Project Site Pictures -->
			<SubTitle topTitle='PROJECT SITE PICTURES' :title="$t('nav.project')" :content='projectText' />
		</div>

		<div id="wrap">
			<div id="pc_img" v-for="(item, index) in projectList">
				<img :src="item.image">
			</div>

			<!-- <ul id="list" class="img_box">
				<li v-for="(item, index) in projectList">
					<img :src="item.image">
				</li>
			</ul>
			<ul id="list" class="img_box" style="margin-top: 19rem;">
				<li v-for="(item, index) in projectList2">
					<img :src="item.image">
				</li>
			</ul> -->
		</div>

		<div id="swipper">
			<el-carousel ref="nop" id="" style="width: 100%;height: 249px;" indicator-position="none" arrow="always">
				<div id="" @touchstart="start($event)" @touchmove="move($event)">
					<el-carousel-item v-for="item in projectList" :key="item.id">
						<div style="width: 100%;" class="img_bg"
							:style="`background: url(${item.image}) no-repeat center`">
						</div>
					</el-carousel-item>
				</div>

			</el-carousel>
		</div>



	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getProjectText,
	getProjectImg
} from '@/utils/api.js'
import SubTitle from './SubTitle'
export default {
	name: 'Project',
	components: {
		SubTitle
	},
	data() {
		return {
			projectText: '',
			projectList: [],
			projectList1: [],
			projectList2: [],

			current: 0,

			type: false,
			startX: '',
			startY: '',
			moveY: '',
			moveX: '',
			startTime: '',
		}
	},
	computed: {
		...mapState(['gray'])
	},
	created() {
		this.getProjectText()
		this.getProjectImg()
	},
	methods: {
		async getProjectText() {
			const res = await getProjectText()
			if (res.code == 200) {
				this.projectText = res.content.content
			}
		},
		async getProjectImg() {
			const res = await getProjectImg()
			if (res.code == 200) {
				this.projectList = res.content
				// console.log("this.projectList: ",this.projectList);
				// this.projectList1 = res.content.filter((i,index) => {
				// 	return index % 2 != 0;
				// });
				// this.projectList2 = res.content.filter((i,index) => {
				// 	return index % 2 == 0;
				// });
				// this.projectList1 = [...this.projectList1, ...this.projectList1]
				// this.projectList2 = [...this.projectList2, ...this.projectList2]
			}
		},
		start(e) {
			this.startX = e.touches[0].clientX;
			this.startY = e.touches[0].clientY;
		},
		move(e) {
			this.moveX = e.touches[0].clientX;
			this.moveY = e.touches[0].clientY;
			var nowtime = new Date().getTime();
			if (this.startTime == undefined || nowtime > this.startTime) {
				if (this.startX - this.moveX <= 0) { // 右滑触发
					this.prev();
					return false;
				} else {
					this.next();
					return false;
				}
			}
		},
		prev() {
			this.$refs.nop.prev();
			this.startTime = new Date().getTime() + 500;
		},
		next() {
			this.$refs.nop.next();
			this.startTime = new Date().getTime() + 500;
		},
	}
}
</script>

<style>
.project {
	width: 100%;
	min-height: 59.8125rem;
	background: url(../assets/bg3.jpg) no-repeat center;
	background-size: cover;
}

.project .box {
	padding: 5rem 0 3.125rem;
	max-width: 75rem;
	margin: 0 auto;
}

.fixed_box {
	width: 100%;
	box-sizing: border-box;
}

.img_box {
	/* width: 100%; */
	/* width: 2000px; */
	/* height: 630px; */
	/* overflow-x: auto ; */
	/* overflow-y: hidden;
		overflow-x: auto;
		white-space: nowrap; */
}

.img_box img {
	position: relative;
	display: inline-block;
	width: 27.1875rem;
	height: 18rem;
}



/* #wrap {
		width: 100%;
		position: relative;
		min-height: 38.8125rem;
		overflow: hidden;
	} */
#wrap {
	width: 87rem;
	position: relative;
	min-height: 38.8125rem;
	overflow: hidden;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	margin: 0 auto;
	justify-content: center;
	padding-left: 1.25rem;
	/* align-items: center; */
}

#swipper {
	display: none;
}

/* #wrap > div {
		display: flex;
		flex-wrap: wrap;
	} */
#wrap>div img {
	width: 27.25rem;
	height: 18.125rem;
	border-radius: 0.5rem;
	margin-top: 1.25rem;
	margin-right: 1.25rem;
}

#list {
	position: absolute;
	left: 0;
	top: 0;
	margin: 0;
	padding: 0;
	-webkit-animation: 20s move infinite linear;
	width: 400%;
	box-sizing: border-box;
}

#list li {
	list-style: none;
	width: 27.1875rem;
	height: 18rem;
	background: #000;
	color: #fff;
	text-align: center;
	float: left;
	margin-right: 1.25rem;
	margin-top: 1.25rem;
	border-radius: 8px;
	box-sizing: border-box;
	overflow: hidden;
}

#list li>div {
	display: block;
}

/* @-webkit-keyframes move {
		0% {
			left: 0;
		}

		100% {
			left: -100%;
		}
	}

	@keyframes move {
		0% {
			left: 0;
		}

		100% {
			left: -100%;
		}
	} */

#wrap:hover #list {
	-webkit-animation-play-state: paused;
	/*动画暂停播放*/
}

@media screen and (max-width:480px) {
	#wrap {
		display: none;
	}

	#swipper {
		display: block;
		padding-bottom: 30px;
	}

	.project {
		min-height: 38.8125rem;
	}

	#swipper .el-carousel .el-carousel__container {
		height: 249px;
	}

	#swipper .img_bg {
		height: 249px;
	}
}
</style>
